export const InquiryStatus = {
  InProgress: 1,
  Completed: 2,
  Confirmed: 3,
  Cancelled: 100000000,
} as const;
export type InquiryStatus = (typeof InquiryStatus)[keyof typeof InquiryStatus];
